import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShareArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M13 1H11V4H3V21H21V4H13V1ZM13 4H11V12.0858L8.5 9.58579L7.08579 11L12 15.9142L16.9142 11L15.5 9.58579L13 12.0858V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShareArrowDown;
